<template>
  <div>
    <!-- 상단 고정 캠페인 배너 -->
    <div class="pdb-20">
      <div>
        <div
          class="d-flex justify-content-between align-items-center pdt-21 pdb-21 pdl-16 pdr-16 bar-bg"
          v-if="status == 'request'"
        >
          <div
            class="t-color-content1 t-body3 l-spacing42 font-r d-flex align-items-center"
            @click="moveToHelp"
          >
            {{ $t("S20002") }}<i class="material-icons mgl-2">help</i>
          </div>

          <div class="d-flex align-items-center">
            <div class="pdl-16 pdr-3 t-body3 t-color-title">
              <span
                class="listPointIcon d-flex justify-content-center align-items-center t-color-white bg-textField2 mgr-4 pdt-2 t-body4"
                >P</span
              >
            </div>
            <div class="t-headline5 t-color-title d-flex align-items-center">
              <div class="mgr-8">
                <img
                  src="images/prize_request/p-image.svg"
                  class="w-24 h-24"
                  alt=""
                />
              </div>
              {{
                memberTotalPoint && memberTotalPoint.present
                  ? memberTotalPoint.present
                  : 0
              }}
            </div>
          </div>
        </div>
        <hr class="divider" />
        <NoData
          v-if="(status == '' || status == 'request') && isNoData"
        ></NoData>
        <NoDataHistory v-if="status == 'history' && isNoData"></NoDataHistory>
      </div>
      <div>
        <div v-if="status == '' || status == 'request'">
          <div class="mgt-16" v-for="(prizes, index) in listData" :key="index">
            <ListItem :prizes="prizes" :type="status"></ListItem>
          </div>
        </div>
        <div
          class="pda-default"
          v-else-if="status == 'history' && listData.length > 0"
        >
          <div class="mdc-card mdc-elevation--z3 pdt-8">
            <div v-for="(prizes, index) in listData" :key="index">
              <ListItem :prizes="prizes" :type="status"></ListItem>
            </div>
          </div>
        </div>
        <infinite-loading
          @infinite="fetchData"
          :identifier="infiniteId"
          spinner="spiral"
        >
          <div slot="no-more" class="mgt-16"></div>
          <div slot="no-results" class="mgt-16"></div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import prizeRequestApi from "@/api/prizeRequestApi.js";
import memberApi from "@/api/memberApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoDataPrizeRequest.vue";
import NoDataHistory from "../common/NoDataPrizeRequestHistory.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    ListItem,
    NoData,
    NoDataHistory,
    InfiniteLoading,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      memberTotalPoint: 0,
      status: null,
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
      this.status = this.$route.query.listType;
      this.isNoData = false;
    },
  },

  mounted() {
    memberApi
      .memberPoint()
      .then((response) => {
        this.memberTotalPoint = response.data.data;
        localStorage.setItem("user_point", response.data.data.present);
      })
      .catch((err) => {});
    this.status = this.$route.query.listType
      ? this.$route.query.listType
      : "request";
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.getParams();

      if (this.totalPages >= this.currentPage) {
        prizeRequestApi
          .prizeProductList(params, this.status)
          .then((response) => {
            responseData = response.data.data;
            // console.log("responseData pp", responseData);

            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }

      // 캠페인 테이터 API 호출(get campaign data)
    },

    // 파라미터 설정(set parameter)
    getParams() {
      const params = {
        // status: this.$route.query.listType,
        // name: '',
        page: this.currentPage,
        size: 10,
        sort: "id,desc",
      };
      return params;
    },
    moveToHelp() {
      this.$router.push({
        name: "PointGuide",
      });
    },
  },
};
</script>



<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.rightToggler {
  cursor: pointer;
}
.toggle-menu {
  width: 112px;
  height: 208px;
  right: -2px;
  top: 24px;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  transition: all 300ms ease-in-out;
}
.toggle-menu > div {
  cursor: pointer;
  color: rgba(129, 129, 129, 0.87) !important;
}

.toggle-menu > div.selected,
.toggle-menu > div:hover {
  color: rgba(0, 0, 0, 0.87) !important;
}
.toggleX300 {
  transform: translateY(-500px);
}
.placeholderImage {
  min-width: 72px;
  height: 72px;
}
.placeholderImage img {
  width: 72px;
  height: 72px;
}
.soldout-message {
  background: #b0b5bc;
  border-radius: 2px;
  margin-top: -10px;
  letter-spacing: 1.2px;
}
.placeholderImage.soldout-image:after {
  position: absolute;
  content: "SOLDOUT";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  transform: rotate(-24deg);
  color: #fff;
  letter-spacing: 1.2px;
}
.placeholderImage.soldout-image:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}
.bar-bg {
  background-color: #f9f9f9;
}
</style>